import { FC } from "react";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import HtmlInlineBlockComponent from "../../block-components/html-inline";

const VDPHtmlInline: FC<IVDPPageBlock> = ({ config, siteData, pageContext, translations }) => {
  return config ? (
    <HtmlInlineBlockComponent
      config={config}
      siteData={siteData}
      pageContext={pageContext}
      translations={translations}
    />
  ) : null;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <VDPHtmlInline
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
